'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-intl/~/intl-messageformat-parser/index.js
 ** module id = 763
 ** module chunks = 73
 **/